import React, { useRef, useState, useCallback } from 'react';
import { Button } from 'antd';
import { trackHeapEvent } from 'utils/analytics';
import PayoutAccountStep, { PayoutAccountStepHandles } from 'pages/PaymentSetup/components/PayoutAccountStep';
import s from './s.module.less';

type Props = Readonly<{
    onNext: () => void;
    onBack: () => void;
}>;

export default function StripePayoutAccountSetup({ onNext, onBack }: Props) {
    const ref = useRef<PayoutAccountStepHandles>(null);
    const [saving, setSaving] = useState(false);

    const handleNext = useCallback(async () => {
        try {
            setSaving(true);
            trackHeapEvent('WebApp - PPA Advance Setting - Click - Payout Account Next', { step: 'payout_account' });
            await ref.current?.onSubmit();
            onNext();
        } finally {
            setSaving(false);
        }
    }, [onNext]);

    const handleSkip = useCallback(() => {
        trackHeapEvent('WebApp - PPA Advance Setting - Click - Skip Payout Account', { step: 'payout_account' });
        onNext();
    }, [onNext]);

    return (
        <div className={s.wrap}>
            <PayoutAccountStep ref={ref} />

            <div className={s.actions}>
                <Button onClick={onBack} className={s.backBtn}>
                    Back
                </Button>
                <Button type="primary" onClick={handleNext} loading={saving} className={s.nextBtn}>
                    Next
                </Button>
                <Button type="link" onClick={handleSkip} className={s.skipBtn}>
                    Skip for now
                </Button>
            </div>
        </div>
    );
}
